export default __webpack_public_path__ + "static/media/Susan-Nash.f300cced.png";